export const LAST_DAYS_FILTER = 'lastDays';
export const PERIOD_FILTER = 'period';
export const ALL = 'all';

export enum ExtractKey {
	BILLING_ID = 'billingId',
	BILL_NUMBER = 'billNumber',
}
